import React from "react";
import { useParams } from "react-router-dom";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import Description from "./Description";

export default function Player({ videos, isLoading, error }) {
  const { videoId } = useParams();
  const video = videos?.find((video) => {
    return video.id === Number(videoId);
  });
  // deciding what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && error) {
    content = <Error message={error} />;
  } else if (!isLoading && !error && !video?.id) {
    content = (
      <>
        <h2 className="text-3xl text-center mt-8">
          No video found for this link!
        </h2>
        <span className="text-md text-center block">
          Click on any video from the playlist at the right.
        </span>
      </>
    );
  } else if (!isLoading && !error && video?.id) {
    content = (
      <>
        <iframe
          width="100%"
          className="aspect-video"
          src={video.url}
          title={video.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <Description video={video} />
      </>
    );
  }

  return (
    <div className="col-span-full w-full space-y-8 lg:col-span-2">
      {content}
    </div>
  );
}
